export const FETCH_ACTIONS_REQUEST = 'FETCH_ACTIONS_REQUEST';
export const FETCH_ACTIONS_SUCCESS = 'FETCH_ACTIONS_SUCCESS';
export const FETCH_ACTIONS_FAILURE = 'FETCH_ACTIONS_FAILURE';
